import { SlotsProvider } from "nano-slots";
import * as React from "react";
import { useIsOffline } from "~/config/offline-storage/useIsOffline.hook";
import { useUser } from "~/config/user/UserProvider";
import { useBreakpoint } from "~/design-system/hooks";
import { createComponentHook } from "~/types";
import { OfflineBanner, useOfflineBannerMountState } from "../OfflineBanner";
import * as Desktop from "./components/Desktop/Desktop";
import * as Mobile from "./components/Mobile/Mobile";

interface LayoutProps {
  children: React.ReactNode;
}

const useLayout = createComponentHook(() => {
  const { breakpoint } = useBreakpoint();
  const { user } = useUser();
  const isOffline = useIsOffline();

  return {
    state: { breakpoint, isOffline, userIsLocked: user.is_locked },
  };
});

function Layout(props: LayoutProps) {
  const { state } = useLayout();
  const { handleExitComplete, isMounted, shouldShow } =
    useOfflineBannerMountState(state.isOffline, state.breakpoint);

  if (state.userIsLocked) {
    return <>{props.children}</>;
  }

  return (
    <div>
      <SlotsProvider>
        <OfflineBanner
          isOffline={state.isOffline}
          visible={shouldShow}
          onExitComplete={handleExitComplete}
        />
        {state.breakpoint === "mobile" ? (
          <Mobile.Layout {...props} offlineBannerVisible={isMounted} />
        ) : (
          <Desktop.Layout {...props} />
        )}
      </SlotsProvider>
    </div>
  );
}

export { Layout };
export type { LayoutProps };
